<template>
	<div class="message-center-body">
        <div class="fx-header">
			<p>交易消息</p>
		</div>
		<!-- <div class="shop-position">
			<img src="~/images/icon/position-icon.png">
			当前卖家店铺：
			<el-select size="mini" v-model="sellerShopId" placeholder="请选择" @change="shopChange">
				<el-option
				v-for="item in shopOptions"
				:key="item.shopId"
				:label="item.shopName"
				:value="item.organid"/>
			</el-select>
		</div> -->
		<div>
			<div class="tr-message">
				<div class="tr-title">交易信息</div>
				<div class="unread">{{count}} 条未读消息 <span @click="cleanMessage">一键清空</span></div>
			</div>
		</div>
		<div class="msg-list">
			<ul v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-immediate="false" infinite-scroll-immediate-check="false">
				<li class="msg-wrapper" v-for="item in msgList" :key="item.id" @click="goDetail(item)">
					<span class="dot" v-if="item.readflag === 0"></span>
					<p class="first-tit">{{item.header}}</p>
					<p class="second-con" :class="{'mg10':item.refundOrderNumber}">{{item.message_alert}}</p>
					<p class="third-no" :class="{'mg5':item.refundOrderNumber}" :title="item.refundOrderNumber?'订单编号:'+ item.message_title + ' 退单编号:'+ item.refundOrderNumber: '订单编号:'+ item.message_title">订单编号：{{item.message_title}}<span v-if="item.refundOrderNumber">&nbsp;&nbsp;&nbsp;退单编号：{{item.refundOrderNumber}}</span></p>
					<p class="forth-time">推送时间：{{item.modifydate}}</p>
				</li>
			</ul>
			<p v-if="loading">加载中...</p>
			<!-- <p v-if="noMore" class="nonono">没有更多了</p> -->
		</div>
	</div>
</template>
<script>

export default {
	name: 'marketing',
	data () {
		return {
			shopOptions: [],
			sellerShopId: '',
			msgList: [],
			count: 0,
			start: 0,
			total: 0,
			loading: false,
			orderParams: {},
			AuthorityList: {
				'07_0000_0000_00': false,
				'07_0001_0000_00': false,
				'07_0001_0001_00': false,
				'07_0001_0004_00': false,
				'07_0001_0007_00': false,
				'07_0001_0010_00': false,
				'07_0002_0000_00': false,
				'07_0002_0001_00': false
			}
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '12-1')
		this.getAuthority('07_0002_0000_00,07_0001_0000_00')
		this.findShopList().then((data) => {
			if (data.length > 0) {
				this.shopOptions = data
				if (window.sessionStorage.getItem('organid')) {
					this.sellerShopId = window.sessionStorage.getItem('organid')
				} else {
					this.sellerShopId = data[0].organid
					window.sessionStorage.setItem('organid', this.sellerShopId)
				}
				this.getMessage()
			}
		})
	},
	computed: {
		noMore () {
			return this.total === 1
		},
		disabled () {
			return this.loading || this.noMore
		}
	},
	methods: {
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		shopChange (item) {
			this.msgList = []
			this.start = 0
			this.loading = false
			this.total = 0
			window.sessionStorage.setItem('organid', this.sellerShopId)
			this.getMessage()
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		goDetail (item) {
			let a = JSON.parse(item.extras)
			if (item.refundOrderNumber) {
				if (a.billState === '0' && !this.AuthorityList['07_0002_0001_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === '1' && !this.AuthorityList['07_0002_0007_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === '2' && !this.AuthorityList['07_0002_0010_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === '3' && !this.AuthorityList['07_0002_0013_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === '4' && !this.AuthorityList['07_0002_0001_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				a.refundid = a.refundOrderId
				let b = JSON.stringify(a)
				window.sessionStorage.setItem('refundOrderParams', b)
				let shopid = ''
				this.shopOptions.forEach(e => {
					if (this.sellerShopId === e.organid) {
						shopid = e.shopId
					}
				})
				let refundTab = { orderStatus: a.billState, active: '', shopId: shopid }
				window.sessionStorage.setItem('refundTab', JSON.stringify(refundTab))
				this.$router.push({ path: 'refundOrderDetail' })
			} else {
				if (a.billState === '0' && !this.AuthorityList['07_0001_0001_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '1' && !this.AuthorityList['07_0001_0004_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '2' && a.isSellerpull === '0' && !this.AuthorityList['07_0001_0007_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '2' && a.isSellerpull === '1' && !this.AuthorityList['07_0001_0010_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '3' && !this.AuthorityList['07_0001_0013_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '4' && !this.AuthorityList['07_0001_0016_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === '5' && !this.AuthorityList['07_0001_0019_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				let billState = ''
				switch (a.billState) {
				case '0':
					billState = '待付款'
					break
				case '1':
					billState = '待接单'
					break
				case '2':
					billState = a.isSellerpull === '1' ? '备货中' : '待发货'
					break
				case '3':
					billState = '待收货'
					break
				case '4':
					billState = '已完成'
					break
				case '5':
					billState = '已取消'
					break
				}
				this.orderParams.orderId = a.orderid
				this.orderParams.statusId = a.statusid
				this.orderParams.differ = a.differ
				this.orderParams.buypullstate = a.buypullstate
				this.orderParams.billState = billState
				this.orderParams.messageid = a.messageId
				let orderParams = JSON.stringify(this.orderParams)
				let aaa = { isSellerpull: a.isSellerpull === '1' }
				aaa.organid = this.sellerShopId
				let shopid = ''
				this.shopOptions.forEach(e => {
					if (this.sellerShopId === e.organid) {
						shopid = e.shopId
					}
				})
				aaa.sellerShopId = shopid
				window.sessionStorage.setItem('tabInfo', JSON.stringify(aaa))
				window.sessionStorage.setItem('orderInfo', orderParams)
				this.$router.push('/main/orderDetail')
			}
		},
		load () {
			this.loading = true
			setTimeout(() => {
				this.start += 15
				this.getMessage()
			}, 1000)
		},
		getMessage () {
			let params = {
				bsflag: 1,
				msgtype: 1,
				start: this.start,
				length: 15,
				organid: this.sellerShopId
			}
			this.$store.dispatch('requestPost', {
				// api: 'urlFS',
				url: `${this.$fxBaseApi.urlQIVShop}/order/messagecenter/get`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.count = res.data.bussinessCount.count
					res.data.bussinessMessage.forEach(element => {
						this.msgList.push(element)
					})
					if (res.data.bussinessMessage.length < 15) {
						this.total = 1
					}
					this.loading = false
				}
			})
		},
		cleanMessage () {
			let params = {
				bsflag: 1,
				msgtype: 1,
				organid: this.sellerShopId
			}
			this.$store.dispatch('requestPost', {
				// api: 'urlFS',
				url: `${this.$fxBaseApi.urlQIVShop}/order/messagecenter/allmessageunreadflag/update`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.loading = false
					this.start = 0
					this.total = 0
					this.msgList = []
					this.getMessage()
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.message-center-body {
	flex: 1
	display flex
	flex-direction column
	padding 16px 0 0 30px;
	box-sizing border-box
	color : #484848
	.shop-position {
		display flex
		align-items: center
		height: 60px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.tr-message {
		// float: left
		text-align: left
		margin : 20px 0 5px 20px
		.tr-title {
			font-size : 16px
			font-weight : bold
			// display : inline-block
			border-left : 4px solid var(--fx-primary-color)
			padding-bottom : 2px
			text-indent: 10px
		}
	}
	.unread{
		// float: left
		margin-left : 15px
		font-size : 14px
		height: 30px
		// margin-bottom : 12px
		margin-top: 8px
		span{
			cursor: pointer
			color : var(--fx-primary-color)
		}
		img{
			display: inline
			vertical-align : middle
			cursor : pointer
			margin : -2px 0 0 12px
		}
	}
	.msg-list{
		// max-height : 500px
		clear: left
		// margin-top : 10px
		margin-bottom : 10px
		height : 100%
		overflow: auto
		&::-webkit-scrollbar {/*滚动条整体样式*/
            width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
            height: 10px;
            scrollbar-arrow-color: red;
        }
        &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,.05);
            background: rgba(0,0,0,0.2);
            scrollbar-arrow-color: red;
        }
        &::-webkit-scrollbar-track {/*滚动条里面轨道*/
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,.05);
            border-radius: 4px;
            background: rgba(0,0,0,.05);
        }
	}
	.msg-wrapper{
		display: flex
		// width : 850px
		text-align: left
		height : 50px
		line-height : 50px
		background-color : #F6FAFF
		border-radius : 10px
		margin-bottom : 12px
		// padding : 16px 24px
		padding-left : 24px
		box-sizing : border-box
		position: relative
		cursor : pointer
		.first-tit{
			font-weight : bold
			font-size : 14px
			margin-bottom : 10px
			width : 25%
		}
		.second-con{
			font-size : 14px
			margin-bottom : 20px
			width : 20%
			text-align : center
			&.mg10{
				margin-bottom: 10px
			}
		}
		.third-no{
			font-size : 13px
			color : #797979
			margin-bottom : 10px
			width : 35%
			text-align : right
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			&.mg5{
				margin-bottom : 5px
			}
		}
		.forth-time{
			font-size : 13px
			color : #797979
			width : 20%
			text-align : center
		}
		.dot{
			position : absolute
			width : 8px
			height : 8px
			border-radius : 50%
			background-color : #fa0601
			top: 12px
			left : 12px
		}
		.look-msg{
			position : absolute
			right : 24px
			bottom : 15px
			color : #5c995e
			font-size : 12px
			text-decoration : underline
		}
	}
	.nonono {
		text-align: center
		margin-bottom: 10px
	}
}
</style>
